var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-hidden"},[_c('Header'),_c('div',{staticClass:"w-full mt-40"},[_c('Carousel')],1),_c('Categories'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }